// extracted by extract-css-chunks-webpack-plugin
module.exports = {"iconPrinter":"TermsConditions__iconPrinter--Q0hM8"};